module.exports = __webpack_public_path__ + "img/thumbnail_BairdsTapir_m_normal.d1ebda43.png";